import React from 'react';
import { IIconProps } from './utils';

export const CloudSuccess = ({
  fill = 'currentColor', height = 20, width = 20, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 20 20" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M6.8763 10.8333L8.1263 12.0833L11.043 9.16667M1.66797 12.5C1.66797 13.8807 2.78726 15 4.16797 15H15.0013C16.8423 15 18.3346 13.5076 18.3346 11.6667C18.3346 9.82572 16.8423 8.33333 15.0013 8.33333C14.7051 8.33333 14.4179 8.37198 14.1444 8.4445C14.0316 8.47442 13.9126 8.41383 13.873 8.30403C13.1784 6.37736 11.334 5 9.16797 5C6.47639 5 4.28155 7.12676 4.17224 9.79148C4.16752 9.90644 4.07437 9.99909 3.9597 10.0086C2.67643 10.1144 1.66797 11.1894 1.66797 12.5Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
  </svg>
);
